input{padding:0 11px;border:1px solid #d9d9d9;height:150px;margin-left:1em}.history-submitted .history.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=medical-history-add-edit.component-SHO7R7NH.css.map */
